const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const {
    Component
} = require('react');

// @common
const OKBarValueArray = require('components/commons/OKBarValueArray/OKBarValueArray');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class ExpensesByCategoryComparativeBars extends Component {

    getTitle(value) {
        const plainAmountObject = getPlainAmountObject({ amount: value, currency: 'EUR' });

        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        );
    }

    render() {
        const { values, colors } = this.props;

        const valuesInCurrency = values.map(value => this.getTitle(value));

        return (
            <OKBarValueArray
                highlightFirst
                names={valuesInCurrency}
                values={values}
                colors={colors}
            />
        );
    }
}

ExpensesByCategoryComparativeBars.propTypes = {
    values: PropTypes.array.isRequired,
    colors: PropTypes.array.isRequired
};

ExpensesByCategoryComparativeBars.defaultProps = {
    values: [],
    colors: []
}

module.exports = ExpensesByCategoryComparativeBars;